import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { marcarFaltanteChequeFisico } from "./ApiServices";
import { idInstrumentoFisico } from "./chequesFisicos.constants";

export default function ModalFaltante({ open, onClose, cheque, onOk }) {
  const [obs, setObs] = useState("");
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setObs("");
    setError("");
  }, [open]);

  const guardar = async () => {
    const id = idInstrumentoFisico(cheque);
    if (!id) return;
    if (!obs.trim()) {
      setError("Indicá qué pasó con el cheque físico (obligatorio).");
      return;
    }
    setGuardando(true);
    setError("");
    try {
      await marcarFaltanteChequeFisico(id, { obs: obs.trim() });
      onOk?.();
      onClose?.();
    } catch (err) {
      setError(err.message || "Error al registrar el faltante");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={guardando ? undefined : onClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>
        Faltante — N° {cheque?.nro_cheque || idInstrumentoFisico(cheque) || ""}
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          {error ? <Alert severity="error">{error}</Alert> : null}
          <Alert severity="warning">
            No cambia la custodia: el cheque sigue en tránsito a Casa Central.
            Solo se anota en el historial.
          </Alert>
          <TextField
            label="Qué ocurrió"
            size="small"
            fullWidth
            required
            multiline
            minRows={2}
            value={obs}
            onChange={(e) => setObs(e.target.value)}
            disabled={guardando}
            placeholder="Ej. no llegó el sobre, no estaba en el lote…"
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={guardando}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="warning"
          onClick={guardar}
          disabled={guardando || !obs.trim()}
          startIcon={
            guardando ? <CircularProgress size={16} color="inherit" /> : null
          }
        >
          Registrar faltante
        </Button>
      </DialogActions>
    </Dialog>
  );
}
